import React, { useState } from "react";
import * as styles from "../../styles/components/product/feature-vertical-tabs.module.css";
import Container from "../container";
import SectionHeader from "../product-section-header";
import { buildImageObj, seoUrl } from "../../lib/helpers";
import Icon from "../icon";
import { Link } from "gatsby";
import { imageUrlFor } from "../../lib/image-url";

const FeatureVerticalTabs = (props) => {
  const { title, caption, features, position } = props;
  const [activeTab, setActiveTab] = useState(features[0].title);

  const activeTabData = features.find((tab) => tab.title === activeTab);
  return (
    <div className={styles.root} id={'toolkit-features'}>
      {title && <SectionHeader title={title} subtitle={caption} position={position} />}
      <Container>
        <div className={styles.tabsWrapper}>
          <div className={styles.tabs}>
            {features.map((tab, index) => (
              <button
                key={index}
                className={
                  tab.title === activeTab ? styles.tab : styles.inactiveTab
                }
                onClick={() => setActiveTab(tab.title)}
              >
                {tab.title}
              </button>
            ))}
          </div>

          {activeTabData.featureItems?.map((feature, index) => {
            const slug =
              feature?.cta?.slug?.__typename === "SanityFeaturePage"
                ? `/product/${feature?.cta?.slug?.correspodingProduct?.slug?.current}/${feature?.cta?.slug?.slug?.current}`
                : `/product/${feature?.cta?.slug?.slug?.current}`;
            return (
              <div key={index} className={styles.feature}>
                {feature.icon && (
                  <img
                    src={imageUrlFor(buildImageObj(feature.icon))
                      .auto("format")
                      .url()}
                    alt={feature.title}
                  />
                )}
                {feature.position === "titleFirst" ? (
                  <>
                    <h3>{feature.title}</h3>
                    <p className={styles.caption}>{feature.caption}</p>
                  </>
                ) : (
                  <>
                    <p className={styles.caption}>{feature.caption}</p>
                    <h3>{feature.title}</h3>
                  </>
                )}
                <p>{feature.description}</p>
                {feature.cta && (
                  <Link
                    to={
                      feature.cta.type === "internal" ? slug : feature.cta.link
                    }
                    className="link"
                  >
                    {feature.cta.title}
                    <Icon symbol="arrow-right" />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default FeatureVerticalTabs;
